export const getCellPositionEducation = (cellString) => {
    switch (cellString) {
        case "Primaria": return "D14";
        case "Secundaria": return "I14";
        case "Técnico o Tecnólogo": return "P14";
        case "Universitaria": return "T14";
        case "Post-grado": return "X14";
        default: return "AA14"; // Return null if no match is found
    }
};

export const getCellPositionTenet = (cellString) => {
    switch (cellString) {
        case "Propia": return "E62";
        case "Posada": return "E63";
        case "Familiar": return "E64";
        case "Alquilada": return "E65";
        case "Invasión": return "E66";
        default: return null; // Return null if no match is found
    }
}

export const getCellPositionType = (cellString) => {
    switch (cellString) {
        case "Casa": return "J62";
        case "Casalote": return "J63";
        case "Finca": return "J64";
        case "Apartamento": return "J65";
        case "Habitación": return "J66";
        case "Inquilinato": return "J67";
        default: return null; // Return null if no match is found
    }
}

export const getCellQuality = (cellString) => {
    switch (cellString) {
        case "Terminada": return "P62";
        case "Semiterminada": return "P63";
        case "Obra negra": return "P64";
        case "Otra": return "P65";
        default: return null; // Return null if no match is found
    }
}

export const getCellPositionZone = (cellString) => {
    switch (cellString) {
        case "Rural": return "F83";
        case "Popular": return "F84";
        case "Invasión": return "F85";
        case "Residencial": return "L83";
        case "Comercial": return "L84";
        case "Industrial": return "L85";
        default: return null; // Return null if no match is found
    }
}

export const getIdTypeDocument = (cellString) => {
    switch (cellString) {
        case "Cédula de ciudadanía": return "CC";
        case "Cédula de extranjería": return "CE";
        case "Tarjeta de identidad": return "TI";
        case "Documento de identificación extranjero": return "DIE";
        case "Pasaporte": return "PA";
        case "Permiso especial de permanencia": return "PEP";
        default: return null; // Return null if no match is found
    }
}

export const getStatus = (status) => {
    switch (status) {
        case 'Scheduled': return 'Programada';
        case 'Started': return 'Iniciada';
        case 'Waiting for conclusion': return 'Esperando conclusión';
        case 'Finished': return 'Finalizada';
        default: return 'Desconocido';
    }
};

